














import { defineComponent, PropType } from '@nuxtjs/composition-api'

export type AuthTab = 'clients' | 'business'

export default defineComponent({
  name: 'AuthTabsSwitcher',
  props: {
    activeTab: {
      type: String as PropType<AuthTab>,
      required: true,
    },
  },
  setup() {
    const tabs: Array<{ id: AuthTab; title: string }> = [
      { id: 'clients', title: 'Клиентам' },
      { id: 'business', title: 'Бизнесу и партнёрам' },
    ]
    return { tabs }
  },
})
